import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const SimpleLogin = () => {
  const location = useLocation();
  return <Navigate to={`/login${location.search}`} replace />;
};

export default SimpleLogin;
